export const IMPORT_OPTIONS = [
  { title: 'IMAGES - NOT PURSUABLE', key: 'imagesNotPursuable' },
  { title: 'IMAGES - REGISTERED', key: 'imagesRegistered' },
  { title: 'DOMAINS - BLACKLISTED', key: 'domainsBlacklisted' },
  { title: 'IMAGES - STATUSES', key: 'imagesStatuses' },
  { title: 'SUBDOMAINS-BLACKLISTED', key: 'subdomainsBlacklisted' }
];
